module.exports = __webpack_public_path__ + "img/doubleArrowDown-white.30460299.png";